import React from 'react'
import ATTabs from '../../components/layoutComponent/tabs/ATTabs'
import { customerTabs } from '../../components/customers/customerConstants'
import CustomerDetails from '../../components/customers/CustomerDetails'
import './Customers.css'
import AtTwoColumnLayout from '../../components/layoutComponent/twoColumnLayout/ATTwoColumnLayout'
import CustomerList from '../../components/customers/CustomerList'
import { useTranslation } from 'react-i18next'
import useCustomerList from '../../customHooks/customer/useCustomerList'
import { PERMISSIONS } from '../../components/common/auth/AuthorizeConstant'

const Customers: React.FC = () => {
  const { t } = useTranslation(['translation'])
  const {
    handleTabSelection,
    selectedTab,
    customerDetails,
    handleCustomerSelection,
    selectedCustomer,
    filteredList,
    query,
    onSearchQueryHandler,
    handleCheckBox,
    checkBoxValue,
    handleCustomerForm,
    showCustomerDetailsForm,
    setSelectedCustomer,
  } = useCustomerList()

  const getJsxConditionally = () => {
    return (
      <AtTwoColumnLayout
        listPanel={
          <CustomerList
            handleCustomerSelection={handleCustomerSelection}
            selectedCustomer={selectedCustomer}
            onSearchQueryHandler={onSearchQueryHandler}
            filteredList={filteredList}
            query={query}
            handleCustomerForm={handleCustomerForm}
            showCustomerDetailsForm={showCustomerDetailsForm}
          />
        }
        detailsPanel={
          <CustomerDetails
            customerInfo={customerDetails?.data}
            isError={customerDetails?.isError}
            selectedTab={selectedTab}
            selectedCustomer={selectedCustomer}
            handleCheckBox={handleCheckBox}
            checkBoxValue={checkBoxValue}
            setSelectedCustomer={setSelectedCustomer}
          />
        }
        widgetName={PERMISSIONS.VIEW_CUSTOMERS}
      />
    )
  }

  return (
    <div className="customer-container multi-tabs hm-class">
      <p className="customer-title px-3 my-0 py-2">{t('common.customer')}</p>
      <div className="customer-content m-3 mt-0 border bg-white">
        <div className="tabs-wrapper pt-2">
          <ATTabs
            tabDetails={customerTabs}
            onTabSelect={handleTabSelection}
            activeKey={selectedTab}
            showIcon={true}
          />
        </div>
        <div className="customer-tab-body">{getJsxConditionally()}</div>
      </div>
    </div>
  )
}

export default Customers
